var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@material-ui/core/TextField';

function TextareaWidget(props) {
    var options = props.options,
        value = props.value,
        disabled = props.disabled,
        readonly = props.readonly,
        autofocus = props.autofocus,
        onBlur = props.onBlur,
        onFocus = props.onFocus,
        schema = props.schema,
        metadata = props.schema.metadata,
        formContext = props.formContext,
        registry = props.registry,
        inputProps = _objectWithoutProperties(props, ['options', 'value', 'disabled', 'readonly', 'autofocus', 'onBlur', 'onFocus', 'schema', 'schema', 'formContext', 'registry']);

    var onChange = function onChange(_ref) {
        var value = _ref.target.value;

        return props.onChange(value ? value : options.emptyValue);
    };

    return React.createElement(TextField, _extends({
        multiline: true
    }, inputProps, {
        margin: 'none',
        rowsMax: options.rows || 4,
        readOnly: metadata.readonly,
        disabled: metadata.readonly,
        autoFocus: autofocus,
        required: metadata.required,
        value: value || '',
        onChange: onChange,
        onBlur: onBlur && function (event) {
            return onBlur(inputProps.id, event.target.value);
        },
        onFocus: onFocus && function (event) {
            return onFocus(inputProps.id, event.target.value);
        },
        fullWidth: true
    }));
}

TextareaWidget.defaultProps = {
    autofocus: false,
    options: {}
};

TextareaWidget.propTypes = process.env.NODE_ENV !== "production" ? {
    schema: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    options: PropTypes.shape({
        rows: PropTypes.number
    }),
    value: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    autofocus: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func
} : {};

export default TextareaWidget;